import React from "react";
import FixedAssetGenericSkeleton from "./FixedAssetGenericSkeleton";

function FixedAssetDetailSkeleton() {
  return (
    <>
      <FixedAssetGenericSkeleton />
    </>
  );
}

export default FixedAssetDetailSkeleton;
